var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.items},_vm._l((_vm.variantsRender),function(item,i){
var _obj, _obj$1;
return _c(item.url ? 'nuxt-link' : 'div',{key:i,tag:"component",class:[
      _vm.$style.item,
      ( _obj = {}, _obj[_vm.$style.active] = item.active, _obj ),
      ( _obj$1 = {}, _obj$1[_vm.$style.image] = !!item.image, _obj$1 ) ],attrs:{"to":item.url ? item.url : false,"title":item.url ? item.title : false}},[(item.image)?_c('component-image',{attrs:{"image":item.image,"cover":"","absolute":"","title":item.title}}):[_vm._v("\n      "+_vm._s(item.title)+"\n    ")]],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }